<div class="timeline-layout">
  <!--@if (selectedPropertyId !== null && viewModeItems.length > 0) {
    <div class="view-mode-selector">
      <tidy-header-select
        [items]="viewModeItems"
        [(ngModel)]="propertyViewMode"
        [showIcons]="true"
        (optionChange)="viewModeChanged.emit($event)"
        [class]="'floating-select' + (windowService.isDesktopRes ? ' dropdown-align-right' : ' compact-padding dropdown-open-upward')" />
    </div>
  }-->
  <div class="property-panel-wrapper" #propertyPanelWrapper>
    <div class="pulse-timeline-property-header">
      <tidy-header-select
        [items]="headerSelectItems"
        [(ngModel)]="selectedHeaderValue"
        (optionChange)="onHeaderItemSelected($event)"
        [icon]="'assets/svg/home.svg'"
        class="floating-select" />
      @if (selectedPropertyId === null) {
        <tidy-small-round-button
          [icon]="'add'"
          [buttonClass]="'glass small'"
          (buttonClick)="addPropertyClicked.emit()" />
      }
    </div>
    <!-- Mobile Address Row - visible only on mobile, always shown -->
    <div class="mobile-address-row">
      <tidy-header-select
        [items]="headerSelectItems"
        [(ngModel)]="selectedHeaderValue"
        (optionChange)="onHeaderItemSelected($event)"
        [icon]="'assets/svg/home.svg'"
        class="floating-select" />
      @if (selectedPropertyId === null) {
        <tidy-small-round-button
          [icon]="'add'"
          [buttonClass]="'glass small'"
          (buttonClick)="addPropertyClicked.emit()" />
      }
    </div>
    @if (selectedPropertyId !== null) {
      <div class="property-info">
      <tidy-text [megaHero]="propertyName" [translate]="false" class="property-name-hero" />
      <!-- Mobile Action Dock - right below property name -->
      <div class="mobile-action-dock">
        @if (!isRentalClient || propertyInfo.gettingStartedLoaded) {
          @if (isRentalClient && propertyInfo.showGettingStarted && propertyInfo.gettingStartedCompletedSteps < propertyInfo.gettingStartedTotalSteps) {
            <tidy-small-button
              [text]="'Get Started'"
              [image]="'assets/svg/rocket-outline.svg'"
              [primary]="true"
              (buttonClick)="onFieldClick('gettingStarted')"
              class="overview-button" />
          } @else {
            <tidy-small-button
              [text]="'Book Cleaning'"
              [image]="'assets/svg/calendar-outline.svg'"
              [primary]="true"
              (buttonClick)="onBookJob()"
              class="overview-button" />
          }
        }
        <tidy-small-round-button
          [icon]="'edit'"
          (buttonClick)="goToEditPropertyPage()" />
        <tidy-small-round-button
          [icon]="'bolt'"
          [selected]="selectedLocationIcon === 'utilities'"
          (buttonClick)="onLocationIconClick('utilities')" />
        <tidy-small-round-button
          [icon]="'local_shipping'"
          [selected]="selectedLocationIcon === 'trash'"
          (buttonClick)="onLocationIconClick('trash')" />
        <tidy-small-round-button
          [icon]="'pest_control'"
          [selected]="selectedLocationIcon === 'pests'"
          (buttonClick)="onLocationIconClick('pests')" />
        <tidy-small-round-button
          [icon]="'gavel'"
          [selected]="selectedLocationIcon === 'ordinances'"
          (buttonClick)="onLocationIconClick('ordinances')" />
        <tidy-small-round-button
          [icon]="locationData?.attributes?.weather?.data?.conditions | weatherIcon"
          [selected]="selectedLocationIcon === 'weather'"
          (buttonClick)="onLocationIconClick('weather')" />
      </div>

      @if (isConsumer && selectedPropertyId !== null) {
        <button class="book-job-btn" (click)="onBookJob()">
          <span class="material-icons">calendar_today</span>
          Book a Cleaning
        </button>
      }

      <!-- Mobile Glass Cards - horizontal scroll -->
      <div class="mobile-glass-cards">
        @if (isLoadingPropertySummary) {
          @if (isRentalClient) {
            <div class="glass-card">
              <tidy-text [smallHelper]="'LISTINGS'" />
              <tidy-text [body]="'Loading...'" class="medium-weight" />
            </div>
          }
          <div class="glass-card">
            <tidy-text [smallHelper]="'NEXT JOB'" />
            <tidy-text [body]="'Loading...'" class="medium-weight" />
          </div>
          <div class="glass-card">
            <tidy-text [smallHelper]="'LAST JOB'" />
            <tidy-text [body]="'Loading...'" class="medium-weight" />
          </div>
          @if (isRentalClient) {
            <div class="glass-card">
              <tidy-text [smallHelper]="'LOW INVENTORY'" />
              <tidy-text [body]="'Loading...'" class="medium-weight" />
            </div>
            <div class="glass-card">
              <tidy-text [smallHelper]="'UNPAID BILLS'" />
              <tidy-text [body]="'Loading...'" class="medium-weight" />
            </div>
          }
        } @else {
          @if (isRentalClient) {
            <div class="glass-card" (click)="onFieldClick('listings')">
              <tidy-text [smallHelper]="'LISTINGS'" />
              <tidy-text [body]="listingsLabel" class="medium-weight" />
              <span class="material-icons glass-card-chevron">chevron_right</span>
            </div>
          }
          <div class="glass-card" (click)="onFieldClick('nextJob')">
            <tidy-text [smallHelper]="'NEXT JOB'" />
            <tidy-text [body]="propertyInfo.nextJob" class="medium-weight" />
            <span class="material-icons glass-card-chevron">chevron_right</span>
          </div>
          <div class="glass-card" (click)="onFieldClick('lastJob')">
            <tidy-text [smallHelper]="'LAST JOB'" />
            <tidy-text [body]="propertyInfo.lastJob" class="medium-weight" />
            <span class="material-icons glass-card-chevron">chevron_right</span>
          </div>
          @if (isRentalClient) {
            <div class="glass-card" (click)="onFieldClick('lowInventory')">
              <tidy-text [smallHelper]="'LOW INVENTORY'" />
              <tidy-text [body]="propertyInfo.lowInventory > 0 ? propertyInfo.lowInventory : '0'" [class]="propertyInfo.lowInventory > 0 ? 'bold yellow' : 'medium-weight'" />
              <span class="material-icons glass-card-chevron">chevron_right</span>
            </div>
            <div class="glass-card" (click)="onFieldClick('unpaidBills')">
              <tidy-text [smallHelper]="'UNPAID BILLS'" />
              <tidy-text [body]="propertyInfo.unpaidBills > 0 ? propertyInfo.unpaidBills : '0'" [class]="propertyInfo.unpaidBills > 0 ? 'bold red' : 'medium-weight'" />
              <span class="material-icons glass-card-chevron">chevron_right</span>
            </div>
          }
        }
      </div>

      <!-- Mobile Sign In Banner for Guest Accounts -->
      @if (isGuestAccount && !windowService.isDesktopRes) {
        <div class="mobile-sign-in-banner">
          <tidy-text [body]="'Save Your Progress:'" class="sign-in-label" />
          <tidy-small-button
            [text]="'Sign In'"
            [primary]="true"
            (buttonClick)="signInClicked.emit()" />
        </div>
      }

      <!-- Desktop property details (hidden on mobile) -->
      <div class="property-details">
        @if (isLoadingPropertySummary) {
          @if (isRentalClient) {
            <div class="details-row">
              <div class="detail-item">
                <div class="detail-label-row">
                  <tidy-text [smallHelper]="'LISTINGS'" />
                </div>
                <tidy-text [mediumBody]="'Loading...'" />
              </div>
            </div>
          }
          <div class="details-row">
            <div class="detail-item">
              <div class="detail-label-row">
                <tidy-text [smallHelper]="'NEXT JOB'" />
              </div>
              <tidy-text [mediumBody]="'Loading...'" />
            </div>
            <div class="detail-item">
              <div class="detail-label-row">
                <tidy-text [smallHelper]="'LAST JOB'" />
              </div>
              <tidy-text [mediumBody]="'Loading...'" />
            </div>
          </div>
          @if (isRentalClient) {
            <div class="details-row">
              <div class="detail-item">
                <div class="detail-label-row">
                  <tidy-text [smallHelper]="'LOW INVENTORY'" />
                </div>
                <tidy-text [mediumBody]="'Loading...'" />
              </div>
              <div class="detail-item">
                <div class="detail-label-row">
                  <tidy-text [smallHelper]="'UNPAID BILLS'" />
                </div>
                <tidy-text [mediumBody]="'Loading...'" />
              </div>
            </div>
          }
        } @else {
          @if (isRentalClient) {
            <div class="details-row">
              <div class="detail-item clickable" (click)="onFieldClick('listings')">
                <div class="detail-label-row">
                  <tidy-text [smallHelper]="'LISTINGS'" />
                  <span class="material-icons chevron">chevron_right</span>
                </div>
                <div class="listings-detail-value">
                  <tidy-text [mediumBody]="listingsLabel" [class]="(propertyInfo.listingsCount || 0) > 0 ? 'bold' : ''" />
                  @if (propertyInfo.listingsPlatforms?.length) {
                    <div class="listing-platform-chips">
                      @for (platform of propertyInfo.listingsPlatforms; track platform) {
                        <span class="listing-platform-chip">{{ platform }}</span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <div class="details-row">
            <div class="detail-item clickable" (click)="onFieldClick('nextJob')">
              <div class="detail-label-row">
                <tidy-text [smallHelper]="'NEXT JOB'" />
                <span class="material-icons chevron">chevron_right</span>
              </div>
              <tidy-text [mediumBody]="propertyInfo.nextJob" [class]="propertyInfo.nextJob?.startsWith('No ') ? '' : 'bold'" />
            </div>
            <div class="detail-item clickable" (click)="onFieldClick('lastJob')">
              <div class="detail-label-row">
                <tidy-text [smallHelper]="'LAST JOB'" />
                <span class="material-icons chevron">chevron_right</span>
              </div>
              <tidy-text [mediumBody]="propertyInfo.lastJob" [class]="propertyInfo.lastJob?.startsWith('No ') ? '' : 'bold'" />
            </div>
          </div>
          @if (isRentalClient) {
            <div class="details-row">
              <div class="detail-item clickable" (click)="onFieldClick('lowInventory')">
                <div class="detail-label-row">
                  <tidy-text [smallHelper]="'LOW INVENTORY'" />
                  <span class="material-icons chevron">chevron_right</span>
                </div>
                <tidy-text [mediumBody]="propertyInfo.lowInventory > 0 ? propertyInfo.lowInventory : '0'" [class]="propertyInfo.lowInventory > 0 ? 'bold yellow' : ''" />
              </div>
              <div class="detail-item clickable" (click)="onFieldClick('unpaidBills')">
                <div class="detail-label-row">
                  <tidy-text [smallHelper]="'UNPAID BILLS'" />
                  <span class="material-icons chevron">chevron_right</span>
                </div>
                <tidy-text [mediumBody]="propertyInfo.unpaidBills > 0 ? propertyInfo.unpaidBills : '0'" [class]="propertyInfo.unpaidBills > 0 ? 'bold red' : ''" />
              </div>
            </div>
          }
        }
        @if (propertyInfo.accessNotes) {
          <div class="access-notes-view">
            <span class="material-icons access-icon">key</span>
            <tidy-text [helper]="propertyInfo.accessNotes" />
          </div>
        }
        @if (selectedPropertyId !== null) {
          <div class="property-data-section">
            <div class="property-data-header">
              <tidy-text [smallHelper]="'PROPERTY DETAILS'" />
              <button class="inline-edit-btn" (click)="togglePropertyDataEdit()">
                <span class="material-icons">{{ isEditingPropertyData ? 'close' : 'edit' }}</span>
              </button>
            </div>

            @if (!isEditingPropertyData) {
              <div class="property-data-view horizontal">
                @if (propertyData?.data?.bedrooms) {
                  <div class="detail-item">
                    <tidy-text [helper]="'Bedrooms'" />
                    <tidy-text [body]="propertyData.data.bedrooms" class="bold" />
                  </div>
                }
                @if (propertyData?.data?.bathrooms) {
                  <div class="detail-item">
                    <tidy-text [helper]="'Bathrooms'" />
                    <tidy-text [body]="propertyData.data.bathrooms" class="bold" />
                  </div>
                }
                @if (propertyData?.data?.living_area_sqft) {
                  <div class="detail-item">
                    <tidy-text [helper]="'Living Area'" />
                    <tidy-text [body]="(propertyData.data.living_area_sqft | formatLocaleNumber) + (' sqft' | translate)" class="bold" />
                  </div>
                }
                @if (propertyData?.data?.lot_size_sqft) {
                  <div class="detail-item">
                    <tidy-text [helper]="'Lot Size'" />
                    <tidy-text [body]="(propertyData.data.lot_size_sqft | formatLocaleNumber) + (' sqft' | translate)" class="bold" />
                  </div>
                }
                @if (propertyData?.data?.year_built) {
                  <div class="detail-item">
                    <tidy-text [helper]="'Year Built'" />
                    <tidy-text [body]="propertyData.data.year_built" class="bold" />
                  </div>
                }
              </div>
              <!-- @if (propertyData?.user_submitted) {
                <tidy-text [smallHelper]="'User entered'" class="data-source-indicator" />
              } -->
            } @else {
              <form [formGroup]="propertyDataForm" class="property-data-edit-form">
                <div class="edit-fields-grid">
                  <div class="edit-field">
                    <tidy-input
                      formControlName="bedrooms"
                      [form]="propertyDataForm.controls.bedrooms"
                      [label]="'Bedrooms'"
                      [type]="'number'"
                      [icon]="'assets/svg/bed-outline.svg'"
                      [submitted]="submitted"
                      [errorMessage]="'Must be a whole number (0–99)'" />
                  </div>
                  <div class="edit-field">
                    <tidy-input
                      formControlName="bathrooms"
                      [form]="propertyDataForm.controls.bathrooms"
                      [label]="'Bathrooms'"
                      [type]="'number'"
                      [icon]="'assets/svg/water-outline.svg'"
                      [submitted]="submitted"
                      [errorMessage]="'Must be a whole number (0–99)'" />
                  </div>
                  <div class="edit-field">
                    <tidy-input
                      formControlName="living_area_sqft"
                      [form]="propertyDataForm.controls.living_area_sqft"
                      [label]="'Living Area (sqft)'"
                      [type]="'number'"
                      [icon]="'assets/svg/resize-outline.svg'"
                      [submitted]="submitted"
                      [errorMessage]="'Must be 0–999,999'" />
                  </div>
                  <div class="edit-field">
                    <tidy-input
                      formControlName="lot_size_sqft"
                      [form]="propertyDataForm.controls.lot_size_sqft"
                      [label]="'Lot Size (sqft)'"
                      [type]="'number'"
                      [icon]="'assets/svg/resize-outline.svg'"
                      [submitted]="submitted"
                      [errorMessage]="'Must be 0–9,999,999'" />
                  </div>
                  <div class="edit-field">
                    <tidy-input
                      formControlName="year_built"
                      [form]="propertyDataForm.controls.year_built"
                      [label]="'Year Built'"
                      [type]="'number'"
                      [icon]="'assets/svg/calendar-outline.svg'"
                      [submitted]="submitted"
                      [errorMessage]="'Must be 1800–current year'" />
                  </div>
                  <div class="edit-field">
                    <tidy-select
                      formControlName="property_type"
                      [form]="propertyDataForm.controls.property_type"
                      [label]="'Property Type'"
                      [items]="propertyTypeItems"
                      [icon]="'assets/svg/home.svg'" />
                  </div>
                </div>
                <div class="edit-actions">
                  <tidy-button
                    [text]="'Save'"
                    [action]="onSavePropertyData"
                    class="primary"
                    [disabled]="isSavingPropertyData" />
                  <tidy-button
                    [text]="'Cancel'"
                    [action]="onCancelPropertyDataEdit.bind(this)"
                    class="secondary" />
                </div>
              </form>
            }
          </div>
        }
        @if (propertyInfo.customFields?.length > 0) {
          <div class="custom-fields-view">
            @for (field of propertyInfo.customFields; track field.label) {
              <div class="detail-item">
                <tidy-text [helper]="field.label" />
                <tidy-text [body]="field.value" class="bold" />
              </div>
            }
          </div>
        }
      </div>

      <div class="location-icons-section">
        <div class="location-icons-row">
          @if (!isLocationExpanded) {
            <button class="location-info-toggle" (click)="onToggleLocationExpand()">
              <span class="info-letter">i</span>
              <span class="material-icons chevron">navigate_next</span>
            </button>
          } @else {
            <button class="location-collapse-btn" (click)="onToggleLocationExpand()">
              <span class="material-icons">chevron_left</span>
            </button>
            <button class="location-icon-btn" (click)="onLocationIconClick('weather')" [class.has-data]="locationData?.attributes?.weather?.data" [class.selected]="selectedLocationIcon === 'weather'">
              <span class="material-icons">{{ locationData?.attributes?.weather?.data?.conditions | weatherIcon }}</span>
            </button>
            <button class="location-icon-btn" (click)="onLocationIconClick('pests')" [class.selected]="selectedLocationIcon === 'pests'">
              <span class="material-icons">pest_control</span>
            </button>
            <button class="location-icon-btn" (click)="onLocationIconClick('utilities')" [class.has-data]="hasUtilitiesData()" [class.selected]="selectedLocationIcon === 'utilities'">
              <span class="material-icons">bolt</span>
            </button>
            <button class="location-icon-btn" (click)="onLocationIconClick('trash')" [class.has-data]="locationData?.attributes?.utility?.data?.trash" [class.selected]="selectedLocationIcon === 'trash'">
              <span class="material-icons">local_shipping</span>
            </button>
            <button class="location-icon-btn" (click)="onLocationIconClick('ordinances')" [class.has-data]="hasOrdinancesData()" [class.selected]="selectedLocationIcon === 'ordinances'">
              <span class="material-icons">gavel</span>
            </button>
          }
        </div>
        @if (selectedLocationIcon) {
          <div class="location-data-panel">
            <div class="data-panel-header">
              <span class="data-panel-title">{{ getSelectedIconTitle() }}</span>
              <button class="data-panel-close" (click)="closeDataPanel()">
                <span class="material-icons">close</span>
              </button>
            </div>
            <div class="data-panel-content">
              @switch (selectedLocationIcon) {
                @case ('weather') {
                  <div class="quick-actions top-actions">
                    <button class="quick-action-btn" (click)="onQuickAction('weather', 'snow-removal')">
                      <span class="material-icons">ac_unit</span>
                      Snow Removal
                    </button>
                  </div>
                  @if (isLoadingLocationData && !locationData) {
                    <div class="loading-state">
                      <ion-spinner name="crescent" />
                      <span>Loading weather data...</span>
                    </div>
                  } @else if (locationData?.attributes?.weather?.data) {
                    <div class="data-item">
                      <span class="data-label">Conditions</span>
                      <span class="data-value">{{ locationData.attributes.weather.data.conditions || 'N/A' }}</span>
                    </div>
                    <div class="data-item">
                      <span class="data-label">Temperature</span>
                      <span class="data-value">{{ locationData.attributes.weather.data.temperature }}°F</span>
                    </div>
                    <div class="data-item">
                      <span class="data-label">Humidity</span>
                      <span class="data-value">{{ locationData.attributes.weather.data.humidity }}%</span>
                    </div>
                    @if (locationData.attributes.weather.data.wind) {
                      <div class="data-item">
                        <span class="data-label">Wind</span>
                        <span class="data-value">{{ locationData.attributes.weather.data.wind.speed }} mph {{ locationData.attributes.weather.data.wind.direction }}</span>
                      </div>
                    }
                    @if (locationData.attributes.weather.data.outdoor_work) {
                      <div class="data-item">
                        <span class="data-label">Outdoor Work</span>
                        <span class="data-value">{{ locationData.attributes.weather.data.outdoor_work.rating | titlecase }}</span>
                      </div>
                    }
                  }
                }
                @case ('pests') {
                  <div class="quick-actions top-actions">
                    <button class="quick-action-btn" (click)="onQuickAction('pests', 'pest-removal')">
                      <span class="material-icons">pest_control</span>
                      Pest Removal
                    </button>
                  </div>
                  <div class="no-data">No pest data available</div>
                }
                @case ('utilities') {
                  <div class="quick-actions top-actions">
                    <button class="quick-action-btn" (click)="onQuickAction('utilities', 'report-outage')">
                      <span class="material-icons">power_off</span>
                      Report Outage
                    </button>
                  </div>
                  @if (isLoadingLocationData && !locationData) {
                    <div class="loading-state">
                      <ion-spinner name="crescent" />
                      <span>Loading utilities data...</span>
                    </div>
                  } @else {
                    @if (locationData?.attributes?.utility?.data?.electric) {
                      <div class="utility-section">
                        <div class="utility-section-header">
                          <span class="material-icons">bolt</span>
                          <span>Electric</span>
                        </div>
                        <div class="data-item">
                          <span class="data-label">Provider</span>
                          <span class="data-value">{{ locationData.attributes.utility.data.electric.provider || 'N/A' }}</span>
                        </div>
                        @if (locationData.attributes.utility.data.electric.rates) {
                          <div class="data-item">
                            <span class="data-label">Avg Rate</span>
                            <span class="data-value">{{ locationData.attributes.utility.data.electric.rates.avg_rate_per_kwh }}/kWh</span>
                          </div>
                        }
                      </div>
                    }
                    @if (locationData?.attributes?.utility?.data?.water) {
                      <div class="utility-section">
                        <div class="utility-section-header">
                          <span class="material-icons">water_drop</span>
                          <span>Water</span>
                        </div>
                        <div class="data-item">
                          <span class="data-label">Provider</span>
                          <span class="data-value">{{ locationData.attributes.utility.data.water.provider || 'N/A' }}</span>
                        </div>
                        @if (locationData.attributes.utility.data.water.rates) {
                          <div class="data-item">
                            <span class="data-label">Avg Rate</span>
                            <span class="data-value">{{ locationData.attributes.utility.data.water.rates.avg_rate }}</span>
                          </div>
                        }
                      </div>
                    }
                    @if (locationData?.attributes?.utility?.data?.internet?.length) {
                      <div class="utility-section">
                        <div class="utility-section-header">
                          <span class="material-icons">wifi</span>
                          <span>Internet</span>
                        </div>
                        @for (provider of locationData.attributes.utility.data.internet; track provider.provider) {
                          <div class="data-item">
                            <span class="data-label">{{ provider.provider }}</span>
                            <span class="data-value">{{ provider.max_speed || 'Available' }}</span>
                          </div>
                        }
                      </div>
                    }
                    @if (!locationData?.attributes?.utility?.data?.electric && !locationData?.attributes?.utility?.data?.water && !locationData?.attributes?.utility?.data?.internet?.length) {
                      <div class="no-data">No utilities data available</div>
                    }
                  }
                }
                @case ('trash') {
                  <div class="quick-actions top-actions">
                    <button class="quick-action-btn" (click)="onQuickAction('trash', 'large-item')">
                      <span class="material-icons">delete_sweep</span>
                      Large Item Pickup
                    </button>
                    <button class="quick-action-btn" (click)="onQuickAction('trash', 'other-pickup')">
                      <span class="material-icons">local_shipping</span>
                      Other Pickup
                    </button>
                  </div>
                  @if (isLoadingLocationData && !locationData) {
                    <div class="loading-state">
                      <ion-spinner name="crescent" />
                      <span>Loading trash data...</span>
                    </div>
                  } @else if (locationData?.attributes?.utility?.data?.trash) {
                    <div class="data-item">
                      <span class="data-label">Provider</span>
                      <span class="data-value">{{ locationData.attributes.utility.data.trash.provider || 'N/A' }}</span>
                    </div>
                    @if (locationData.attributes.utility.data.trash.pickup_day) {
                      <div class="data-item">
                        <span class="data-label">Pickup Day</span>
                        <span class="data-value">{{ locationData.attributes.utility.data.trash.pickup_day }}</span>
                      </div>
                    }
                  }
                }
                @case ('ordinances') {
                  <div class="quick-actions top-actions">
                    <button class="quick-action-btn" (click)="onQuickAction('ordinances', 'request-permit')">
                      <span class="material-icons">assignment</span>
                      Request Permit
                    </button>
                  </div>
                  @if (isLoadingPropertyCodes && !propertyCodesData) {
                    <div class="loading-state">
                      <ion-spinner name="crescent" />
                      <span>Loading ordinances data...</span>
                    </div>
                  } @else if (hasOrdinancesData()) {
                    <div class="ordinances-content">
                      @for (item of getOrdinancesSummary(); track item.category) {
                        <div class="ordinance-row">
                          <div class="ordinance-category">
                            <span class="material-icons">{{ item.icon }}</span>
                            <span class="category-name">{{ item.category }}</span>
                          </div>
                          <div class="ordinance-summary">{{ item.summary }}</div>
                        </div>
                      }
                    </div>
                  }
                }
              }
            </div>
          </div>
        }
      </div>
      </div>
    }
  </div>
  @if (selectedPropertyId !== null && !isTimelineHidden) {
    <div class="timeline-container">
      <div class="timeline-scroll" #timelineScroll>
      @if (hasNoEvents) {
        <div class="timeline-events empty-state">
          <div class="timeline-event is-past">
            <div class="event-content" data-date="">
              <span class="event-title timeline-link" (click)="onLogJob()">Log Job</span>
            </div>
            <div class="event-node">
              <div class="node-dot"></div>
            </div>
            <div class="event-date">
              <span></span>
            </div>
          </div>
          <div class="timeline-event is-today">
            <div class="event-content" data-date="">
              <span class="event-title empty-message">Today</span>
            </div>
            <div class="event-node">
              <div class="node-dot"></div>
            </div>
            <div class="event-date">
              <span>Today</span>
            </div>
          </div>
          <div class="timeline-event is-future">
            <div class="event-content" data-date="">
              <span class="event-title timeline-link" (click)="onAddJob()">Add Job</span>
            </div>
            <div class="event-node">
              <div class="node-dot"></div>
            </div>
            <div class="event-date">
              <span></span>
            </div>
          </div>
        </div>
      } @else {
        <div class="timeline-events">
          @if (!hasPastEvents) {
            <div class="timeline-event is-past">
              <div class="event-content" data-date="">
                <span class="event-title timeline-link" (click)="onLogJob()">Log Job</span>
              </div>
              <div class="event-node">
                <div class="node-dot"></div>
              </div>
              <div class="event-date">
                <span></span>
              </div>
            </div>
          }
          @for (event of events; track trackByIndex($index)) {
            <div class="timeline-event" [class.is-today]="isToday(event)" [class.is-past]="isPast(event)" [class.is-future]="isFuture(event)">
              <div class="event-content" [attr.data-date]="event.date">
                <span class="event-title">{{ event.title }}</span>
              </div>
              <div class="event-node">
                <div class="node-dot"></div>
              </div>
              <div class="event-date">
                <span>{{ event.date }}</span>
              </div>
            </div>
          }
          @if (!hasFutureEvents) {
            <div class="timeline-event is-future">
              <div class="event-content" data-date="">
                <span class="event-title timeline-link" (click)="onAddJob()">Add Job</span>
              </div>
              <div class="event-node">
                <div class="node-dot"></div>
              </div>
              <div class="event-date">
                <span></span>
              </div>
            </div>
          }
        </div>
      }
      </div>
    </div>
  }
</div>

<!-- Location Modal (uses popup-overlay for consistent styling) -->
<tidy-location-modal
  [type]="selectedLocationIcon"
  [locationData]="locationData"
  [isLoading]="isLoadingLocationData"
  (closed)="closeDataPanel()"
  (quickAction)="onQuickAction($event.category, $event.action)" />
